export async function fetchNcmSuggestion(product) {
  try {
    const response = await fetch(process.env.VUE_APP_MENU_AI_URL + 'ncm-suggestion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(product)
    });

    return response.json();
  } catch (error) {
    throw new Error('Erro ao buscar sugestão de NCM: ' + error.message);
  }
}

export async function fetchImageUrl(category, description) {
  try {
    const response = await fetch(process.env.VUE_APP_MENU_AI_URL + 'fill-image-only', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        category: category,
        description: description
      })
    });

    if (!response.ok) {
      throw new Error('Erro ao buscar URL da imagem: ' + response.statusText);
    }

    const data = await response.json();
    return data.url;
  } catch (error) {
    throw new Error('Erro ao buscar URL da imagem: ' + error.message);
  }
}
